import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { switchMap } from 'rxjs/operators';

import { AppComponent } from '../app.component';
import { HubService } from '../services/hub.service';
import { Hub } from '../types/hub';

@Component({
  selector: 'hub-messages',
  template: `<hub-sub-menu></hub-sub-menu>
<new-message [inHub]="hub"></new-message>
<messages [inHub]="hub"></messages>`,
})

export class HubMessagesComponent implements OnInit {
  hub: Hub;
  errorMessage: string;

  constructor(
    private route: ActivatedRoute,
    private hubService: HubService,
  ) {}

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    this.route.params.pipe(
      switchMap((params: Params) => this.hubService.getHub(+params['hubid']))
    ).subscribe(
        hub => this.setHub(hub),
        error => this.errorMessage = <any>error,
      );

  }

  setHub(hub: Hub) {
    this.hub = hub;
  }

}
